import { Dialog } from '@cimplico/components';

type EditWorkpaperConfirmProps = {
    procedureTemplateChange?: boolean;
    checklistTemplateChange?: boolean;
    onClose: () => void;
    onEdit: () => void;
};

function EditWorkpaperConfirm({
    procedureTemplateChange,
    checklistTemplateChange,
    onClose,
    onEdit,
}: EditWorkpaperConfirmProps): JSX.Element {
    return (
        <Dialog
            type="info"
            title="Edit Workpaper"
            description={`Editing the template may affect all progress of ${
                procedureTemplateChange && checklistTemplateChange
                    ? 'procedures and checklist items.'
                    : procedureTemplateChange
                    ? 'procedures.'
                    : 'checklist items.'
            }`}
            primaryAction="Edit"
            secondaryAction="Cancel"
            isOpen
            onClose={onClose}
            onPrimaryActionClick={onEdit}
            onSecondaryActionClick={onClose}
        />
    );
}
export default EditWorkpaperConfirm;
